<template>
    <!--
      This example requires updating your template:
  
      ```
      <html class="h-full bg-white">
      <body class="h-full">
      ```
    -->
    <div>
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog as="div" class="relative z-50 lg:hidden" @close="sidebarOpen = false">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300"
                    enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300"
                    leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-900/80" />
                </TransitionChild>

                <div class="fixed inset-0 flex">
                    <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                        enter-from="-translate-x-full" enter-to="translate-x-0"
                        leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                        leave-to="-translate-x-full">
                        <DialogPanel class="relative mr-16 flex w-full max-w-[12rem] flex-1">
                            <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                                enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100"
                                leave-to="opacity-0">
                                <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                                    <button type="button" class="-m-2.5 p-2.5" @click="sidebarOpen = false">
                                        <span class="sr-only">Close sidebar</span>
                                        <XMarkIcon class="h-6 w-6 text-white" aria-hidden="true" />
                                    </button>
                                </div>
                            </TransitionChild>
                            <!-- Sidebar component, swap this element with another sidebar if you like -->
                            <AsideBar />
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Static sidebar for desktop -->
        <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-48 lg:flex-col">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <AsideBar />
        </div>

        <div class="sticky top-0 z-40 flex items-center gap-x-6 bg-gray-900 px-4 py-4 shadow-sm sm:px-6 lg:hidden">
            <button type="button" class="-m-2.5 p-2.5 text-gray-400 lg:hidden" @click="sidebarOpen = true">
                <span class="sr-only">Open sidebar</span>
                <Bars3Icon class="h-6 w-6" aria-hidden="true" />
            </button>
            <div class="flex-1 text-sm font-semibold leading-6 text-white">{{ tabName }}</div>
            <button @click="router.push('/setting')">
                <span class="sr-only">Your profile</span>
                <img class="h-8 w-8 rounded-full bg-white" :src="url" alt="" />
            </button>
        </div>

        <main class="relative lg:pl-48 sm:h-[100vh] py-8 pb-4">
            <router-view v-slot="{ Component, route }">
                <keep-alive :include="['ErrorStatistics', 'MediaStatistics']">
                    <component :is="Component" />
                </keep-alive>
            </router-view>
        </main>

    </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import AsideBar from '@/components/AsideBar.vue'
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import {
    Bars3Icon,
    XMarkIcon, ComputerDesktopIcon, LinkIcon
} from '@heroicons/vue/24/outline'

import { useRoute, useRouter } from 'vue-router'
import store from '@/store'
import {
    GlobeAsiaAustraliaIcon,
    // FolderIcon,
    InboxIcon,
    // UsersIcon,
    SparklesIcon,
    BeakerIcon,
    CubeIcon,
    ChartPieIcon
} from '@heroicons/vue/24/outline'
const route = useRoute()
const router = useRouter()
const navigation = [
    {
        name: '公共',
        icon: GlobeAsiaAustraliaIcon,
        current: false,
        children: [
            { name: '数据看板', href: '/dashboard', icon: ChartPieIcon, current: true },
            { name: '任务管理', href: '/', icon: InboxIcon, current: false },
        ],
    },
    {
        name: '网站监测',
        icon: GlobeAsiaAustraliaIcon,
        current: false,
        children: [
            {
                name: '首页更新', href: '/website/home-update', icon: ComputerDesktopIcon, current: false
            },
            { name: '错敏信息', href: '/website/error-sensitive', icon: SparklesIcon, current: false },
            {
                name: '栏目更新', href: '/website/column-update', icon: CubeIcon, current: false
            },
            { name: '链接可用性', href: '/website/link-availability', icon: LinkIcon, current: false },
        ],
    },
    {
        name: '公众号监测',
        icon: BeakerIcon,
        current: false,
        children: [
            { name: '错敏信息', href: '/wechat/error-sensitive', icon: SparklesIcon, current: false },
        ],
    },
    // { name: 'Projects', href: '#', icon: FolderIcon, current: false },
    // { name: 'Calendar', href: '#', icon: CalendarIcon, current: false },
    // { name: 'Documents', href: '#', icon: DocumentDuplicateIcon, current: false },
    // { name: 'Reports', href: '#', icon: ChartPieIcon, current: false },
]
const tabName = computed(() => {
    let tab = '任务管理';
    navigation.forEach((navItem) => {
        if (navItem.href === route.path) {
            tab = navItem.name;
        }
        if (navItem.children) {
            navItem.children.forEach((childItem) => {
                if (childItem.href === route.path) {
                    tab = childItem.name;
                }
            });
        }
    });
    return tab;
});
const url = computed(() => {
    return store.state.imgUrl
})

const userInfo = computed(() => {
    return store.state.userInfo
})

watch(() => userInfo.value, (val) => {
    if (val.avatar) {
        store.dispatch('getImage')
    }
})

const sidebarOpen = ref(false)
const loginOrigin = ref(false)
onMounted(() => {
    loginOrigin.value = Boolean(window.localStorage.getItem("login_app1"));
    if (loginOrigin.value && route.path !== 'free-mode/views') {
        store.dispatch('getUserInfo')
    } else {
        router.replace('/login')
    }
})
</script>
